<template>
    <div>
      <!-- Table Card -->
      <div class="card">
        <div class="card-body">
          <!-- Table Section -->
          <div class="table-responsive signal-table">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                  <!-- <th scope="col"
                    @click="sortTable('role_id')" 
                    :class="{'sortable col-description': true, 'active': roleStore.sort_by === 'role_id'}"> -->
                    <span>Role</span>
                    <!-- <i v-if="roleStore.sort_by === 'role_id' && roleStore.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="roleStore.sort_by === 'role_id' && roleStore.order === 'desc'" class="fa fa-sort-desc"></i> -->
                  </th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in roleStore.roles" :key="index">
                  <td>{{ item.name }}</td>
                  <td>
                    <EditRoleModal :id="item.id" @permissions-updated="handlePermissionsUpdated" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination -->
          <div class="pagination-wrapper">
            <div class="pagination-container">
              <button @click="changePage(1)" :disabled="currentPage === 1">
                <img src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" />
              </button>
              <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                <img src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" />
              </button>
              <span>Page <input type="number" v-model.number="currentPage" @change="changePage(currentPage)" min="1" :max="totalPages" /> of {{ totalPages }}</span>
              <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                <img src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" />
              </button>
              <button @click="changePage(totalPages)" :disabled="currentPage === totalPages">
                <img src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" />
              </button>
            </div>
            <div class="total-count">
              Displaying roles {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, roleStore.totalEntries) }} of {{ roleStore.totalEntries }}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script setup>
import { ref, onMounted, computed } from 'vue';
import EditRoleModal from './EditRoleModal.vue';
import { useRoleStore } from '@/store/admin/role';
import { usePermissionStore } from '@/store/admin/permission';

const roleStore = useRoleStore();
const permissionStore = usePermissionStore();
const currentPage = ref(1);
const itemsPerPage = ref(10);

const totalPages = computed(() => {
  return Math.ceil(roleStore.totalEntries / itemsPerPage.value) || 1;
});

// 處理權限更新事件
const handlePermissionsUpdated = async () => {
  const userInfo = JSON.parse(localStorage.getItem('Admin'));
  if (userInfo && userInfo.role_id) {
    await permissionStore.fetchPermissions(userInfo.role_id);
  }
};

onMounted(() => {
  roleStore.fetchRoles(currentPage.value, itemsPerPage.value);
});

// 表格排序處理邏輯
const sortTable = (field) => {
  if (roleStore.sort_by === field) {
    roleStore.order = roleStore.order === 'asc' ? 'desc' : 'asc';
  } else {
    roleStore.sort_by = field;
    roleStore.order = 'desc';
  }
  roleStore.fetchRoles(currentPage.value, itemsPerPage.value);
};

const changePage = (page) => {
  if (page < 1) page = 1;
  if (page > totalPages.value) page = totalPages.value;
  currentPage.value = page;
  roleStore.fetchRoles(page, itemsPerPage.value);
};
</script>

<style scoped>
.card {
  margin: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 20px;
  position: relative;
}

.no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }

.table-responsive {
  margin-top: 20px;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table-hover tbody tr:hover {
  color: #495057;
  background-color: rgba(0, 0, 0, 0.075);
}

.table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.total-count {
  font-size: 16px;
  color: #666;
}

.signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
  min-width: 100px !important;
}

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
  